/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Sessions_DeletedSessionFileResponseDto } from '../models/Wealthlane_Sessions_DeletedSessionFileResponseDto';
import type { Wealthlane_Sessions_UploadSessionCompletedResponseDto } from '../models/Wealthlane_Sessions_UploadSessionCompletedResponseDto';
import type { Wealthlane_Shared_Hosting_Dtos_CreatedApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_CreatedApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SessionManagementService {
  /**
   * @returns Wealthlane_Shared_Hosting_Dtos_CreatedApiResponse OK
   * @throws ApiError
   */
  public static postApiIdentityApiSessionsStart(): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_CreatedApiResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/identity/api/sessions/start',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param sessionId
   * @returns Wealthlane_Sessions_UploadSessionCompletedResponseDto OK
   * @throws ApiError
   */
  public static postApiIdentityApiSessionsComplete(
    sessionId?: string
  ): CancelablePromise<Wealthlane_Sessions_UploadSessionCompletedResponseDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/identity/api/sessions/complete',
      query: {
        sessionId: sessionId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param sessionFileId
   * @returns Wealthlane_Sessions_DeletedSessionFileResponseDto OK
   * @throws ApiError
   */
  public static deleteApiIdentityApiSessionsFiles(
    sessionFileId: string
  ): CancelablePromise<Wealthlane_Sessions_DeletedSessionFileResponseDto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/identity/api/sessions/files/{sessionFileId}',
      path: {
        sessionFileId: sessionFileId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }
}
